"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuickBuyButton = void 0;
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _common = require("../../common");
var _hooks = require("./hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const renderIcon = (state, hover) => {
  switch (state) {
    case _common.QUICK_BUY_BUTTON_STATE_LOADING:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.OriflameSpinner, {
        "data-testid": _common.QUICK_BUY_LOADING_ICON,
        fontSize: "inherit"
      });
    case _common.QUICK_BUY_BUTTON_STATE_SUCCESS:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.AddToBagFilled, {
        "data-testid": _common.QUICK_BUY_FILLED_ICON,
        fontSize: "inherit"
      });
    default:
      if (hover) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.AddToBagFilled, {
          "data-testid": _common.QUICK_BUY_FILLED_ICON,
          fontSize: "inherit"
        });
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.AddToBag, {
        "data-testid": _common.QUICK_BUY_OUTLINED_ICON,
        fontSize: "inherit"
      });
  }
};
const QuickBuyButton = ({
  addToBasketMethod,
  currentPrice,
  currentProductCode,
  lineNumber,
  name,
  originalItemCode,
  placement,
  position,
  hasAutoSubscription,
  isMultiShade,
  onQuickBuyButtonClick,
  ...restProps
}) => {
  const [state, setState] = (0, _react.useState)(_common.QUICK_BUY_BUTTON_STATE_DEFAULT);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  (0, _hooks.useQuickBuyEvents)({
    currentProductCode,
    setState
  });
  const onClickEvent = (0, _hooks.useOnClickEvent)({
    addToBasketMethod,
    currentPrice,
    currentProductCode,
    lineNumber,
    name,
    originalItemCode,
    placement,
    position,
    isMultiShade,
    hasAutoSubscription,
    onQuickBuyButtonClick
  });
  const dispatchOnClickEvent = (0, _react.useCallback)(() => {
    if (onClickEvent instanceof CustomEvent) {
      if (onClickEvent.type === AddToBasketEvent.Name) {
        setState(_common.QUICK_BUY_BUTTON_STATE_LOADING);
      }
      window.dispatchEvent(onClickEvent);
    }
  }, [onClickEvent]);
  const onClick = (0, _react.useCallback)(event => {
    event.preventDefault();
    event.stopPropagation();
    if (onClickEvent instanceof CustomEvent && state === _common.QUICK_BUY_BUTTON_STATE_DEFAULT) {
      if (onQuickBuyButtonClick) {
        onQuickBuyButtonClick({
          event: onClickEvent,
          initialState: state,
          setState
        });
      } else {
        dispatchOnClickEvent();
      }
    }
  }, [dispatchOnClickEvent, onClickEvent, onQuickBuyButtonClick, state]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": `${getTestId('quick-buy')}-${currentProductCode}`,
    color: "default",
    hoverIcon: renderIcon(state, true),
    size: "large",
    state: state,
    variant: "contained",
    onClick: onClick,
    ...restProps,
    children: renderIcon(state, false)
  });
};
exports.QuickBuyButton = QuickBuyButton;
